module.exports = __webpack_public_path__ + "static/media/No Joint Spce.a46e3deb.png";